// Portado de src/components/tratamento/Medico.astro (site Astro).
import type { ReactNode } from "react";

import { MEDICO } from "@/lib/itv/site";

const RQES_PADRAO = ["RQE 121770 · NUTROLOGIA", "RQE 118488 · MED. DO ESPORTE", "RQE 113822 · ORTOPEDIA"];

export interface MedicoProps {
  paragrafos: ReactNode[];
  foto?: string;
  /** Páginas locais citam só Nutrologia e Medicina do Esporte (limite do CFM). */
  rqes?: string[];
}

export function Medico({ paragrafos, foto: fotoMedico = "/img/emagrecimento/medico.webp", rqes = RQES_PADRAO }: MedicoProps) {
  return (
    <section className="medico">
      <div className="container">
        <div className="medico-cartao">
          <div className="medico-midia">
            <img
              className="medico-foto"
              src={fotoMedico.replace(/\.(png|jpg|jpeg)$/i, ".webp")}
              alt="Dr. Thiago Viana"
              width={460}
              height={540}
              loading="lazy"
            />
          </div>
          <div className="medico-texto">
            <p className="sobretitulo">O MÉDICO</p>
            <h2>Dr. Thiago Viana</h2>
            <div className="medico-colunas">
              {paragrafos.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <ul className="medico-rqes">
              <li>{MEDICO.crm}</li>
              {rqes.map((r) => <li key={r}>{r}</li>)}
            </ul>
            <a className="btn-contorno" href="/sobre/">
              Conhecer o Dr. Thiago
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
